import {create} from "zustand";

const useGateStore = create((set) => ({
    isGateCreated: false,
    isGateStatusUpdated: false,
    isGateDeleted: false,

    setGateCreated: (isGateCreated) => set({isGateCreated}),
    setGateStatusUpdated: (isGateStatusUpdated) => set({isGateStatusUpdated}),
    setGateDeleted: (isGateDeleted) => set({isGateDeleted}),
}));

export default useGateStore